import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Typography,
} from '@mui/material';
import { useApiGet } from '../../../utils/httpClient';
import { getLocalChapterResources } from '../../../endpoints/resources';

const ButtonLink = ({ href, label }) => (
  <Button
    size="small"
    variant="text"
    color="primary"
    href={href}
    target="_blank"
    rel="noopener"
  >
    {label}
  </Button>
);

const LCResources = ({ id, lcAccess, lcAction }) => {
  const { data: localChapterResources } = useApiGet(
    ['local-chapter-resources'],
    getLocalChapterResources,
    {
      enabled: true,
      retry: 1,
    },
    { chapterId: id }
  );

  if (!localChapterResources) {
    return <Typography variant="body1">Loading...</Typography>;
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={6} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Resource Quick Links" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/05/TreasurersMonthlyReportNocalc_202505_FINAL_8fc30544-2d03-11f0-8a8d-325096b39f47.pdf"
                  label={'Treasurers Monthly Report to Chapter'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/10/TreasurersMonthlyReportWCalculations_202502_Final2.pdf"
                  label={'Treasurers Monthly Report to Chapter (with autocalc)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href=" https://www.peointernational.org/wp-content/uploads/2023/10/TemplateforMinutesofLCrMeeting_2024_FINAL.docx"
                  label={'Template for Minutes of Local Chapter Meeting (Word)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/10/TemplateforMinutesofLCrMeeting_2024_FINAL_85181da2-1fbe-11f0-ab53-325096b39f47.pdf"
                  label={'Template for Minutes of Local Chapter Meeting (PDF)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/04/Constitution-Bylaws-and-Standing-Rules-of-the-P.E.O.-Sisterhood-_dc6409c3-671e-4edd-a0fe-ae63106c5689.pdf"
                  label={'P.E.O. Constitution'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2025/05/LCSuppyOrderForm_202506_Final_8fc306b6-2d03-11f0-b7cf-325096b39f471.pdf"
                  label={'Local Chapter Supply Order Form (PDF)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://eorders.peointernational.org/"
                  label={'Official Emblem Order Form (Online)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/10/Official-Emblem-Order-Form_3.2024_FINAL.docx"
                  label={'Official Emblem Order Form (Word)'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2023/10/Corresponding-Secretarys-Monthly-Report-to-Chapter-Word.docx"
                  label={
                    "Corresponding Secretary's Month Report to Chapter (Word)"
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="/library"
                  label={'Search P.E.O. Resource Library on the Hub'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} sm={6} padding paddingTop={5}>
        <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
          <CardHeader title="Instructions to Officers of Local Chapters (IOLC)" />
          <CardContent>
            <Grid container>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_9.2024_9ebcfd70-54b1-4e4a-999b-b3d39ebe4a8f.pdf"
                  label={'Complete IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_President_9.2024_9ebcfd70-54c8-4b73-bf8c-e6c45ef158db.pdf"
                  label={'President IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Vice-President_1.2024_9ebcfd70-54cd-41aa-8cf1-ef6e9589ca13.pdf"
                  label={'Vice President IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Recording-Secretary_1.2024_9ebcfd70-54ca-4f6f-9e08-5d4dcbfb973b.pdf"
                  label={'Recording Secretary IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Corresponding-Secretary_9.2024_9ebcfd70-54bf-4843-8740-a2468f2233c1.pdf"
                  label={'Corresponding Secretary IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Treasurer_9.2024_9ebcfd70-54cb-4c8a-a828-2d2e5c9a7176.pdf"
                  label={'Treasurer IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Chaplain_1.2024_9ebcfd70-54bc-424c-b0fc-16737c4a996d.pdf"
                  label={'Chaplain IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Guard_9.2024_9ebcfd70-54c4-487b-9e89-ba7aad207e06.pdf"
                  label={'Guard IOLC'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/02/IOLC_Policies_9.2024_9ebcfd70-54c6-4129-9e3b-9b2113d454a2.pdf"
                  label={'IOLC Policies'}
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonLink
                  href="https://www.peointernational.org/wp-content/uploads/2024/09/IOLC_Exhibits_9.2024_9ebcfd70-54c1-4f0e-8967-30a73f72114f.pdf"
                  label={'IOLC Exhibits'}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
      {lcAction && (
        <Grid item xs={12} sm={6} padding paddingTop={5}>
          <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2 }}>
            <CardHeader title="Annual Report Items" />
            <CardContent>
              <Grid container>
                <Grid item xs={12}>
                  <ButtonLink
                    href={`/roster/${localChapterResources.roster_form_id}`}
                    label={'View 2025 Roster Form'}
                  />
                </Grid>
                <Grid item xs={12}>
                  <ButtonLink
                    href={`/irs/${localChapterResources.irs_form_id}`}
                    label={'View 2025 IRS-LC Form'}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

export default LCResources;
